import type { ICalendarEventsResponse } from '@/types/shared-types'

export const fetchCalendarEventsList = (locale: string) =>
  $fetch<ICalendarEventsResponse>('/api/v1/contentful/investor/event-calendar', {
    query: {
      locale,
    },
  })

export const useCalendarEvents = async () => {
  const { locale } = useI18n()
  const { data, pending } = await useAsyncData<ICalendarEventsResponse>(
    'investor-event-calendar',
    () => fetchCalendarEventsList(locale.value),
    {
      watch: [locale],
    },
  )

  return {
    events: computed(() => data.value?.events ?? []),
    total: computed(() => data.value?.total ?? 0),
    isLoading: pending,
  }
}
